// eslint-disable-next-line max-len
import TitleCaseBottom from 'components/features/cases/NextComponents/cases/moscow-exchange/title-case/title-case-bottom';
// eslint-disable-next-line max-len
import TitleCaseMiddle from 'components/features/cases/NextComponents/cases/moscow-exchange/title-case/title-case-middle';
import TitleCaseTop from 'components/features/cases/NextComponents/cases/moscow-exchange/title-case/title-case-top';
import FullWrapper from 'core/FullWrapper';

import cn from './style.module.sass';

export type DescriptionType = {
    name: string;
    details: string;
};

export type MediaLink = {
    title: string;
    href: string;
};

type CompanyLinkType = {
    name: string;
    link: string;
};

export type CompanyInfoType = {
    company: string;
    companyLink: CompanyLinkType[];
    text: string;
    mediaLinks?: MediaLink[];
    info?: string;
    icon?: string;
};

type TitleCaseProps = {
    title: string;
    subtitle?: string;
    descriptions: DescriptionType[];
    companyInfo?: CompanyInfoType;
};

export default function TitleCase({ title, subtitle, descriptions, companyInfo }: TitleCaseProps) {
    return (
        <FullWrapper className={cn.titleCase}>
            <TitleCaseTop title={title} subtitle={subtitle} />
            <TitleCaseMiddle descriptions={descriptions} />
            {companyInfo && (
                <TitleCaseBottom
                    company={companyInfo.company}
                    companyLink={companyInfo.companyLink}
                    text={companyInfo.text}
                    mediaLinks={companyInfo.mediaLinks}
                    info={companyInfo.info}
                    icon={companyInfo.icon}
                />
            )}
        </FullWrapper>
    );
}
